export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            route: "",
            routeList: [
                {
                    label: "基础链接",
                    children: [
                        {
                            label: '服务中心',
                            value: "/packageService/center/index"
                        },
                        {
                            label: '领券中心',
                            value: "/packageGlobal/coupon/index"
                        },
                        {
                            label: '线上课程列表',
                            value: "/packageOnline/list/index"
                        },
                        {
                            label: '活动列表',
                            value: "/pages/activity/index"
                        },
                        {
                            label: '商品列表',
                            value: "/pages/shop/index"
                        },
                        {
                            label: '关于我们',
                            value: "/pages/agreement/aboutus"
                        },
                        {
                            label: '商学院',
                            value: "/packageSxy/index/index"
                        }
                    ]
                },
                {
                    label: "分销",
                    children: [
                        {
                            label: "服务中心",
                            value: "/packageService/identity/index"
                        }
                    ]
                }
            ]
        };
    },
    mounted () {},
    watch: {
        modelValue: {
            handler (newVal) {
                this.route = newVal;
            },
            immediate: true,
            deep: true
        },
        route (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        onChange (val) {
            this.route = val;
        }
    }
};
